import { render, staticRenderFns } from "./ClinicBilling.vue?vue&type=template&id=36d84409"
import script from "./ClinicBilling.vue?vue&type=script&lang=js"
export * from "./ClinicBilling.vue?vue&type=script&lang=js"
import style0 from "./ClinicBilling.vue?vue&type=style&index=0&id=36d84409&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports